import { useState, useEffect } from "react";
import Logo from "../icons/logo.jsx";
import "../styles/header.style.scss";
import { Link, NavLink } from "react-router-dom";
//import Logos from '../icons/slogo.jsx'
function Header() {
  const [isOpen, setOpen] = useState(false);
  function handleCheck(e) {
    setOpen(e.target.checked);
  }
  return (
    <header>
      <div
        className={`ctn-bg ${isOpen ? "active" : ""}`}
        onClick={() => {
          setOpen(false);
        }}
      ></div>
      <div className={`header-container`}>
        <Link to="/">
          <Logo fill={"#293d70"} />
        </Link>
        <div className="menu-icon">
          <input
            className="menu-icon__cheeckbox"
            type="checkbox"
            checked={isOpen}
            onChange={handleCheck}
          />
          <div>
            <span></span>
            <span></span>
          </div>
        </div>
        <nav className={`ctn-link ${isOpen ? "active" : ""}`}>
          <ul className="nav-link">
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <NavLink to="/">Accueil</NavLink>
            </li>
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <NavLink to="/ventes">Ventes</NavLink>
            </li>
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <NavLink to="/about">A propos</NavLink>
            </li>
            <li
              onClick={() => {
                setOpen(false);
              }}
            >
              <NavLink to="/contact" className="btn-link">
                <button className="btn-contact">Contact</button>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
export default Header;
